module.exports = __webpack_public_path__ + "media/customizations/rksouthhoa/back-1b7edd72e0be968ee7b0249dcd8802ab.jpg";